'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');

var Media_Control = React.createClass({
  render: function () {
    return (
      <div className="component-SimpleCom">
        <img width="100%" height="100%" src={assetsHelper.getComponentAsset('media_control')} alt=""/>
      </div>
    )
  }
});

module.exports = Media_Control;



// WEBPACK FOOTER //
// ./src/views/Components/Media_Control.jsx